<div class="card-wrapper">
  <div class="row flex-item">
    <div class="col-sm-6 btn-box">
      <h5>Fascicolo riferito</h5>

      <button *ngIf="fascicoloAssociato == null && fascicoloTemp && fascicoloTemp.fascicoloTemp && fascicoloTemp.fascicoloTemp.id"  type="button"  class="btn btn-primary" (click)="getFascicoloTempAssocia()">Riprendi bozza fascicolo</button>
      <button *ngIf="fascicoloAssociato == null && fascicoloTemp && (!fascicoloTemp.fascicoloTemp || (fascicoloTemp.fascicoloTemp && !fascicoloTemp.fascicoloTemp.id))"  type="button"  class="btn btn-primary" (click)="getFascicoloTempAssocia()">Associa fascicolo</button>

      <div *ngIf="fascicoloAssociato">
        <a [routerLink]="['/' + getFascicoloPath(), fascicoloAssociato.id]" >Fascicolo {{fascicoloAssociato.intestazione.campi.posizione}}</a>
      </div>
    </div>
    <div *ngIf="false" class="col-sm-3 btn-box">
      <hr class="line-vertical"/>
      <h5>Documenti correlati</h5>
      <button type="button" [disabled] = "CitationsDocumentLenght === 0" class="btn btn-outline-primary mb-10">Citazioni ({{CitationsDocumentLenght}})</button>
      <button type="button" [disabled] = "SimilarDocumentLenght === 0" class="btn btn-outline-primary">Doc simili ({{SimilarDocumentLenght}})</button>
      <hr class="line-vertical"/>
    </div>
    <!-- <div class="col-sm-2 btn-box">

    </div> -->
    <div class="col-sm-6 btn-box">
      <h5>Informazioni estratte</h5>
      <button (click)="onShowMetaData()" [disabled] = "Metadatanumber === 0" type="button" class="btn btn-outline-primary">Metadati ({{Metadatanumber}})</button>
    </div>
  </div>
</div>
